<div class="row h-100 m-0">
	<div class="col-md-6 offset-md-3 col-sm-10 offset-sm-1 h-100 d-flex">
		<form #f="ngForm" (ngSubmit)="onSubmit(f)" class="align-self-center block-02 p-3 w-100">
			<section class="bl-header pb-2 mb-2 d-flex">
				<h2 class="flex-grow-0">
					Register new user
				</h2>
				<div class="action flex-grow-1">

				</div>
			</section>
			<mat-form-field class="w-100" appearance="outline">
				<mat-label>Email</mat-label>
				<input type="email" name="registerEmail"  placeholder="Ex. pat@example.com"
				       matInput ngModel email required
				>
			</mat-form-field>
			<mat-form-field class="w-100" appearance="outline">
				<input type="password" name="registerPassword"
				       matInput ngModel required placeholder="Password"
				/>
			</mat-form-field>
			<mat-form-field class="w-100" appearance="outline">
				<input type="password" name="conformRegisterPassword" placeholder="Confirm password"
				       matInput ngModel required
				/>
			</mat-form-field>

			<div class="w-100 flex justify-end items-center space-x-4 pt-2 pb-2">
        <a routerLink="/login" class="">Already have an account?</a>
        <app-button-ui type="submit"> Register </app-button-ui>
			</div>
		</form>
	</div>
</div>
